export function table(config, Alpine) {
  return {
    xScrolled: false,
    init() {
      console.log("table active");
    },
    checkTableScroll(e) {
      console.log(e.target.scrollLeft);
      if (e.target.scrollLeft > 20) {
        this.xScrolled = true;
      } else {
        this.xScrolled = false;
      }
    }
  };
}
